export const preprocessPercentage = (value: string) => {
  const parsed = parseInt(value)
  if (Number.isNaN(parsed)) {
    return ""
  }

  return Math.min(100, parsed) / 100
}
